import LoadingModal from '@acorn-portal/shared/src/components/modal/LoadingModal';
import { useAppDispatch } from '@acorn-portal/shared/src/hooks/reduxHook';
import useGetRenewalDetails from '@acorn-portal/shared/src/hooks/useGetRenewalDetails';
import { PolicyOverview } from '@acorn-portal/shared/src/services/api';
import { clearDocuments } from '@acorn-portal/shared/src/store/policyDocuments.slice';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import { Box } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import NoRenewalsCopy from '../NoRenewalsCopy';
import RenewalListItem from './item';

interface IRenewalListProps {
	policies: PolicyOverview[] | undefined;
}

const RenewalList: FC<IRenewalListProps> = ({ policies }) => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { getPolicyAndRateRenewal } = useGetRenewalDetails();
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		dispatch(clearDocuments());
	}, [dispatch]);

	const handleSelect = async (policyToken: string, policyNumber: string) => {
		setLoading(true);
		await getPolicyAndRateRenewal(policyToken, policyNumber, () => {
			navigate(ROUTE_PATHS.renewalMakeAChangeSummary);
		});
	};

	return (
		<>
			<LoadingModal open={loading} message='Loading renewal details...' />
			<Box
				sx={(theme) => ({
					width: '70%',
					margin: '0 auto',
					textAlign: 'center',
					paddingBottom: '2rem',
					[theme.breakpoints.down('md')]: {
						width: '100%',
					},
				})}
			>
				<Box>
					{policies && policies.length > 0 ? (
						policies.map((x) => <RenewalListItem key={x.policyNumber} policy={x} onSelect={handleSelect} />)
					) : (
						<NoRenewalsCopy />
					)}
				</Box>
			</Box>
		</>
	);
};

export default RenewalList;
